import { Configuration, PopupRequest, LogLevel } from "@azure/msal-browser";
import { azureConfig } from "./azureConfig";

// MSAL configuration for SPA
export const msalConfig: Configuration = {
  auth: {
    clientId: azureConfig.clientId,
    authority: `https://login.microsoftonline.com/${azureConfig.tenantId}`,
    redirectUri: azureConfig.redirectUri,
    navigateToLoginRequestUrl: false, // Important for SPA
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: true, // Allow redirects in iframe for SPA
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        // Logging disabled
      }
    }
  },
};

// Scopes requested at interactive login. We request our own API scope so the user
// consents to it up front; MSAL automatically adds openid/profile.
export const loginRequest: PopupRequest = {
  scopes: [azureConfig.apiScope],
};

// Request used to silently acquire the access token sent to our backend API.
// Its audience matches our app registration, which the backend validates.
export const apiTokenRequest: PopupRequest = {
  scopes: [azureConfig.apiScope],
};
